import './ButtonIcon.less'

const ButtonIcon = ({ imgSrc }) => {
  return <img src={imgSrc} alt='' className='button-icon' />
}

export default ButtonIcon
